<template>
  <v-snackbar v-model="snackbar" :color="settings.type" :timeout="4000" bottom left>
    <span :class="`${ arabic ? 'arFont' : '' }`">{{ settings.message }}</span>
    <v-btn color="white" dark text small @click="close()">
      <v-icon size="12">close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  methods:{
    close(){

    }
  },
  computed:{
    snackbar(){
      return this.$store.state.globalSnackBar
    },
    settings(){
      return this.$store.state.globalSnackBarSetting
    },
    language() {
			return this.$store.state.language;
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language];
		},
		arabic() {
			if (this.$store.state.language == "ar")
				return true;
		},
  }
}
</script>

<style>

</style>